
export default {
    methods: {
        goBack() {
            return this.$router.go(-1);
        },
    },
    data() {
        return {
            showError: false,
        }
    },
}
